import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from "flowbite-react";
import { useState, useEffect } from "react";

export default function ItemTable({ items, opModal }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(items);
  }, [items]);

  return (
    <div className="overflow-x-auto rounded-lg border-2 border-white shadow-sm">
      <Table striped hoverable>
        <TableHead className="bg-gray-800">
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            Item Name
          </TableHeadCell>
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            Note
          </TableHeadCell>
          <TableHeadCell className="text-gray-300 uppercase tracking-wider">
            <span className="sr-only">Edit</span>
          </TableHeadCell>
        </TableHead>
        <TableBody className="divide-y divide-gray-700">
          {data.map((item, index) => (
            <TableRow
              key={item.id}
              className={`${
                index % 2 === 0 ? "bg-gray-800" : "bg-gray-900"
              } hover:bg-gray-700 transition-colors`}
            >
              <TableCell className="whitespace-nowrap font-medium text-white">
                {item.item_name}
              </TableCell>
              <TableCell className="text-gray-300">{item.note || "-"}</TableCell>
              <TableCell>
                <Button size="sm" onClick={() => opModal(item.id)}>
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {data.length === 0 && (
            <TableRow>
              <TableCell colSpan={3} className="text-center py-8 text-gray-400">
                No items found. Add items here to use them when creating jobs.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
